import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { catalogueOrderByState, catalogueQuery, catalogueViewModeState } from '../../../api/products/catalogue';
import CataloguePageListContent from './CataloguePageListContent';
import CataloguePageListContentSkeleton from './CataloguePageListContentSkeleton';
import CataloguePageListFilterCheckbox from './CataloguePageListFilterCheckbox';
import CataloguePageListPagination from './CataloguePageListPagination';
import CataloguePageListToolbar from './CataloguePageListToolbar';

export interface CataloguePageListProps extends StandardDivProps<CataloguePageListClassKey> {
  fullWidth?: boolean;
}

export type CataloguePageListClassKey = 'root';

const themeSettings = { name: 'CataloguePageList' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<CataloguePageListClassKey, {}>({
      root: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
      },
    }),
  themeSettings,
);

const CataloguePageList = React.forwardRef<HTMLDivElement, CataloguePageListProps>(
  ({ className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });

    const catalogueLoadable = useRecoilValueLoadable(catalogueQuery);
    const [catalogueView, setCatalogueView] = useRecoilState(catalogueViewModeState);
    const [catalogueOrder, setCatalogueOrder] = useRecoilState(catalogueOrderByState);

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {/* <CataloguePageListFilter /> */}
        <CataloguePageListFilterCheckbox />
        <CataloguePageListToolbar
          catalogueView={catalogueView}
          onCatalogueViewChange={setCatalogueView}
          catalogueOrder={catalogueOrder}
          onCatalogueOrderChange={setCatalogueOrder}
        />
        {catalogueLoadable.state === 'hasValue' && (
          <>
            <CataloguePageListPagination />
            <CataloguePageListContent catalogueView={catalogueView} catalogue={catalogueLoadable.contents} />
            <CataloguePageListPagination />
          </>
        )}
        {catalogueLoadable.state === 'loading' && (
          <>
            <CataloguePageListContentSkeleton />
          </>
        )}
      </div>
    );
  },
);

CataloguePageList.displayName = 'CataloguePageList';

export default withThemeProps(themeSettings)(CataloguePageList);
